import { type YEntry } from '@databases/collab/y-entry';
import { type Database } from '@databases/model/database';
import { type FieldType } from '@databases/model/field';

interface ClearValueParams {
  entry: YEntry;
  fieldId: string;
  fieldType: FieldType;
}

export function clearValue(
  ydb: Database,
  { entry, fieldId, fieldType }: ClearValueParams
): void {
  ydb.mutate(() => {
    entry.removeValue(fieldId);
    entry.setValue(fieldId, fieldType);
  });
}
